import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const YourFacility = props => {
  const { facilityInfo } = props;

  const facilityCode = facilityInfo?.schoolFacilityCode;
  const facilityName = facilityInfo?.schoolName;

  return (
    <>
      <p className="vads-u-margin-top--0">
        This is the facility we have in your profile.
      </p>
      <p className="school-info-bar">
        <span className="vads-u-margin-left--2p5">{`${facilityCode} - ${facilityName}`}</span>
      </p>
    </>
  );
};

YourFacility.propTypes = {
  facilityInfo: PropTypes.object,
};

const mapStateToProps = state => ({
  facilityInfo: state.form.data.schoolInfo,
});

export default connect(mapStateToProps)(YourFacility);
